import { getRequestTypeDictSelector } from '@Store/selectors/dictionarySelector';
import { TypeDict } from 'types';
import { useAppSelector } from '.';

const useFindRequestType = (): {
  findRequestTypeBy: (
    criteria: string | number,
    searchBy: 'codeDesc' | 'codeNum' | 'code'
  ) => TypeDict;
} => {
  const dictionary = useAppSelector(getRequestTypeDictSelector);

  const findRequestTypeBy = (
    criteria: string | number,
    searchBy: 'codeDesc' | 'codeNum' | 'code'
  ): TypeDict => {
    return (
      dictionary.find((item) => item[searchBy] === criteria) || dictionary[0]
    );
  };

  return { findRequestTypeBy };
};

export default useFindRequestType;
